import React from 'react'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'
import { InputField } from 'Components/reusable/InputFields/InputField'
import { IParsedExperience } from 'types/cvParserInterfaces'

/** @notExported */
interface IExperienceInputsProps {
  /** Experience the CV states for a skill, role or industry */
  value: IParsedExperience
  /** Called with the edited experience */
  onChange: (value: IParsedExperience) => void
  /** Prefix of the inputs' test ids */
  testIdPrefix: string
}

/**
 * Inputs for the experience a parsed CV states: years, since which year and when last used
 *
 * @returns The inputs
 * @notExported
 */
const ExperienceInputs: React.FC<IExperienceInputsProps> = ({ value, onChange, testIdPrefix }) => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  const field = (key: keyof IParsedExperience, label: string, min: number, max: number) => (
    <InputField
      type="number"
      label={label}
      value={value[key] ?? ''}
      min={min}
      max={max}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        onChange({ ...value, [key]: e.target.value === '' ? null : Number(e.target.value) })
      }
      insetLabel
      data-testid={`${testIdPrefix}-${key}`}
    />
  )

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {field('experienceYears', t('admin.parse.result.experienceYearsLabel'), 0, 60)}
      {field('sinceYear', t('admin.parse.result.sinceYearLabel'), 1950, currentYear)}
      {field('lastUsed', t('admin.parse.result.lastUsed'), 1950, currentYear)}
    </Box>
  )
}

export default ExperienceInputs
